import React from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { sendEvent } from "../../utils/Events";
import "./CardMusic.css";


const CardMusic = ({ data }) => {

  const verVideo = () => {
    sendEvent("modal", { type: data.url });
  };

  return (
    <div className="music_card_continainer">
      <div className="music_card_img_container">
        <img
          className="music_card_img_img"
          src={data.thumb}
          alt={data.titulo}
        />
      </div>
      <div className="music_card_info_container">
        <section className="music_card_info_title_container">
          <h3>{data.titulo}</h3>
          <h5>{data.descripcion}</h5>
        </section>
        <section className="music_card_info_btn_container">
          <button className="music_card_info_btn_btn" onClick={() => verVideo() }>
            <MdOutlineKeyboardArrowRight size={25} className="music_card_info_btn_icon" />
          </button>
        </section>
      </div>
    </div>
  );

};

export default CardMusic;